export default "__VITE_ASSET__CGFPrn5c__"